import { Form, Select } from 'antd';
import { NamePath } from 'antd/lib/form/interface';
import { useGetAllInvestorCategoryValues } from '../services/hooks';

export const InvestorTypeSelect = ({
  name,
  label,
  placeholder,
}: {
  name: NamePath;
  label: string;
  placeholder: string;
}) => {
  const { data, isFetching } = useGetAllInvestorCategoryValues();

  return (
    <Form.Item label={label} name={name}>
      <Select
        className="min-w-[200px]"
        mode="multiple"
        placeholder={placeholder}
        allowClear
        loading={isFetching}
        filterOption={(input, option) =>
          option?.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        options={data?.allInvestorCategoryValues?.map((category) => ({
          value: category.idInvestorCategory,
          label: category.name,
        }))}
        labelInValue
      />
    </Form.Item>
  );
};
